export default __webpack_public_path__ + "static/media/icon-blue-lock.7cd7c31e.svg";